import { compose, map, path, propOr } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import IconText from '../../../../../components/presentation/IconText'
import MinicrudsSelect from '../../../../../containers/minicruds/select/MinicrudsSelect'
import { COLORS } from '@btime/constants'

const useSelectedCategoriesIds = () => {
  const form = useChecklistForm()
  return compose(map(path(['selectedCategory', 'id'])), propOr([], 'categories'))(form)
}

const SelectOrTitleCategory = ({ category, index }) => {
  const { t } = useTranslation('editChecklist')
  const { setSelectedCategory } = useChecklistFormActions()
  const selectedCategoriesIds = useSelectedCategoriesIds()

  const hasCategorySelected = !!category.selectedCategory.id

  return (
    <MinicrudsSelect
      entity="checkListCategory"
      onChange={(v, l, { origin }) => setSelectedCategory(index, origin)}
      filter={({ value }) => !selectedCategoriesIds.includes(value)}
      selectedLabel={category.selectedCategory.name}
      value={category.selectedCategory.id}
      actionContent={
        <IconText
          iconName="BsFillCaretDownFill"
          iconSize=".7rem"
          gutter={0.2}
          size="h5"
          noMargin
          color={hasCategorySelected ? COLORS.dark2 : COLORS.dark4}
          label={category.selectedCategory.name || t('selectCategory')}
        />
      }
    />
  )
}

export default SelectOrTitleCategory
